const SCENE_LINES = {
  tornado:
    'A dramatic emergency-alert composition: a tornado funnel descending on a dark plains horizon, ominous low clouds, occasional lightning. The top 18% of the frame is a solid black band, completely empty, NO text, NO letters, NO numbers, NO symbols, NO logos in that band — a separate WARNING banner overlay will be placed on top of it later as a DOM element outside the image. The rest of the frame contains only the tornado scene with no signage, no road signs, no graffiti, no markings, no readable text of any kind anywhere.',
  'multiple_people':
    'A sunny beach with calm ocean and a dolphin breaching the water.',
  'single_female':
    'An upscale clothing or shoe boutique window display, warm interior light.',
  'single_male':
    'A sleek sports car driving down an open coastal road at golden hour.',
} as const;

export type TriggeredScene = keyof typeof SCENE_LINES;

export function triggeredPrompt(scene: TriggeredScene, companyName: string): string {
  return [
    'Cartoonish, infographic-style illustration.',
    SCENE_LINES[scene],
    `Lower 18% of the frame is a clean dark band — it will be overlaid by branding outside the image. Aimed at advertising for ${companyName}.`,
    'Strictly no text, no letters, no numbers, no words, no signage with text, no shop names visible, no street signs, no labels.',
    'No logos of any company, no brand marks, no watermarks anywhere in the image.',
    'Pure imagery only. Aspect 16:9.',
  ].join(' ');
}
